import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  to: "",
  from: "",
  status: "",
  createdBy: "",
  reference: "",
  orderType: "",
  companyName: "",
};

const orderFilterSlice = createSlice({
  name: "orderFilter",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
  },
});

export const { setFilter } = orderFilterSlice.actions;
export default orderFilterSlice.reducer;
